import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=5a2b469a&"
import script from "./Title.vue?vue&type=script&lang=js&"
export * from "./Title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2b469a')) {
      api.createRecord('5a2b469a', component.options)
    } else {
      api.reload('5a2b469a', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=5a2b469a&", function () {
      api.rerender('5a2b469a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Sidepanel/Title.vue"
export default component.exports